<template>
  <div class="pt-5 pl-2 sm:pl-4 flex md:hidden flex-col megamenu__parent megamenu__parent--christmas">
    <router-link
      :to="dynamicProductPath('ready_birthday')"
      class="megamenu__link relative p-2 sm:p-3 lg:p-4 flex flex-col flex-grow-1 shadow text-center"
    >
      <div class="megamenu__icon embed-responsive mb-0 lg:mb-n2 mt-n4">
        <BirthdayNumberSvg class="icon embed-responsive-item image-contain" />
      </div>
      <p class="font-medium mt-O mb-0 ml-auto mr-auto relative">
        {{ t('birthday') }}
      </p>
    </router-link>
  </div>
</template>

<script setup>
import { useI18n } from 'vue-i18n'

import BirthdayNumberSvg from "@/components/svg/navbarMenu/BirthdayNumberSvg.vue";
import { useCategoriesStore } from '@/stores/CategoriesStore'

const { t } = useI18n()
const { dynamicProductPath } = useCategoriesStore()
</script>

<i18n>
  {
    "cs": {
    "birthday": "Narozeniny",
    "christmas": "Valentýn",
    "easter": "Velikonoce"
},
    "sk": {
    "birthday": "Narodeniny",
    "christmas": "Valentín",
    "easter": "Veľká noc"
},
    "pl": {
    "birthday": "Urodziny",
    "christmas": "Walentynki",
    "easter": "Wielkanoc"
},
    "hu": {
    "birthday": "Szülinap",
    "christmas": "Valentin-nap",
    "easter": "Húsvét"
},
    "de": {
    "birthday": "Geburtstag",
    "christmas": "Valentinstag",
    "easter": "Ostern"
},
    "at": {
    "birthday": "Geburtstag",
    "christmas": "Valentinstag",
    "easter": "Ostern"
},
    "ro": {
    "birthday": "Aniversare",
    "christmas": "Valentine's Day",
    "easter": "Paște"
},
    "fr": {
    "birthday": "Anniversaire",
    "christmas": "Saint-Valentin",
    "easter": "Pâques"
},
    "it": {
    "birthday": "Compleanno",
    "christmas": "San Valentino",
    "easter": "Pasqua"
}
  }
</i18n>
